import styled from 'styled-components';
import { breakpoints } from 'styles';
import { isConstruction } from 'config';

export const BackgroundContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  background: linear-gradient(#f4f4f3, #ffffff 512px);
  padding: 32px 36px;

  @media (max-width: ${breakpoints.l}px) {
    padding: 16px;
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;

  h1 {
    font-size: 44px;
    line-height: 48px;
  }
`;

export const Type = styled.p`
  font-size: 18px;
  line-height: 20px;
  font-family: ${({ theme }) => theme.fontFamily};
  text-transform: ${isConstruction ? 'uppercase' : 'capitalize'};
  color: ${({ theme }) => theme.colors[isConstruction ? 'grey4' : 'grey6']};
  font-weight: ${isConstruction ? 'bold' : 'regular'};
  margin: 24px 0 4px;
`;

export const Container = styled.div`
  padding-bottom: 48px;
`;

export const ProductHeader = styled.div`
  margin: 24px 0;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 32px 0;
`;

export const ProductOffer = styled.div`
  background: ${({ theme }) => theme.colors.background};
  margin: 32px 0;
  padding: 24px;
  border-radius: ${isConstruction ? '16px' : '32px'};

  p {
    margin-bottom: 16px;
  }

  button {
    width: 100%;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
